import { z } from "zod";

export const profileEmailSchema = z.object({
  id: z.number(),
  emailType: z.string().nullable(),
  emailTypeLabel: z.string(),
  sentAt: z.string(),
  isDelivered: z.boolean(),
  isOpened: z.boolean(),
  isClicked: z.boolean(),
  isBounced: z.boolean(),
  isComplained: z.boolean(),
  isRejected: z.boolean(),
});

export const profileEmailTotalsSchema = z.object({
  received: z.number(),
  delivered: z.number(),
  opened: z.number(),
  clicked: z.number(),
  notDelivered: z.number(),
});

export const deliveryWarningSchema = z.object({
  reason: z.string(),
  occurredAt: z.string(),
});

export const profileEmailsResponseSchema = z.object({
  data: z.array(profileEmailSchema),
  totals: profileEmailTotalsSchema,
  deliveryWarning: deliveryWarningSchema.nullable(),
});

export const emailEventSchema = z.object({
  id: z.number(),
  eventType: z.string(),
  occurredAt: z.string(),
  link: z.string().nullable(),
  bounceType: z.string().nullable(),
  bounceSubType: z.string().nullable(),
});
